import { fromJSON } from '@arcgis/core/geometry/support/jsonUtils';
import { geojsonToArcGIS } from '@terraformer/arcgis';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { useUscgMapContext } from '../LayersTab/UscgMapContext';

type EventMapButtonProps = {
  name: string;
  geometry: GeoJSON.Geometry;
};

export const useGoToGeometry = () => {
  const { mapView } = useUscgMapContext();

  return async (geometry: GeoJSON.Geometry) => {
    if (!mapView) return;

    const target = fromJSON(geojsonToArcGIS(geometry));
    if (target) {
      await mapView.goTo(target);
    }
  };
};

export const EventMapButton: React.FC<EventMapButtonProps> = ({
  name,
  geometry,
}) => {
  const { isMapVisible } = useUscgMapContext();
  const goToGeometry = useGoToGeometry();

  if (!isMapVisible) return null;

  return (
    <StylishNewButton
      className="button--icon"
      title="Jump to map"
      aria-label={`Jump to ${name} on map`}
      onClick={async (e) => {
        e.stopPropagation();
        await goToGeometry(geometry);
      }}
    >
      <SharedIcon iconName="map" size="sm" />
    </StylishNewButton>
  );
};
